export default function reload() {
    return 'reload'
}